import apiClient from './apiClient';

export interface CatalogItem {
  id: number;
  name: string;
  code?: string;
}

export interface ProvinceItem extends CatalogItem {}

export interface MunicipalityItem extends CatalogItem {
  province_id: number;
}

export interface DistrictItem extends CatalogItem {
  municipality_id: number;
}

export interface InsuranceCompanyItem extends CatalogItem {}

export interface InsurancePlanItem extends CatalogItem {
  insurance_company_id: number;
  company_name?: string;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export const catalogService = {
  async getNationalities(): Promise<CatalogItem[]> {
    const res = await apiClient.get<ApiResponse<CatalogItem[]>>('/catalogs/nationalities');
    return res.data.data ?? [];
  },

  async getProvinces(): Promise<ProvinceItem[]> {
    const res = await apiClient.get<ApiResponse<ProvinceItem[]>>('/catalogs/provinces');
    return res.data.data ?? [];
  },

  async getMunicipalities(provinceId?: number): Promise<MunicipalityItem[]> {
    const params = provinceId ? `?province_id=${provinceId}` : '';
    const res = await apiClient.get<ApiResponse<MunicipalityItem[]>>(`/catalogs/municipalities${params}`);
    return res.data.data ?? [];
  },

  async getDistricts(municipalityId?: number): Promise<DistrictItem[]> {
    const params = municipalityId ? `?municipality_id=${municipalityId}` : '';
    const res = await apiClient.get<ApiResponse<DistrictItem[]>>(`/catalogs/districts${params}`);
    return res.data.data ?? [];
  },

  async getIdentificationTypes(): Promise<CatalogItem[]> {
    const res = await apiClient.get<ApiResponse<CatalogItem[]>>('/catalogs/identification-types');
    return res.data.data ?? [];
  },

  async getInsuranceCompanies(): Promise<InsuranceCompanyItem[]> {
    const res = await apiClient.get<ApiResponse<InsuranceCompanyItem[]>>('/catalogs/insurance-companies');
    return res.data.data ?? [];
  },

  async getInsurancePlans(companyId?: number): Promise<InsurancePlanItem[]> {
    const params = companyId ? `?company_id=${companyId}` : '';
    const res = await apiClient.get<ApiResponse<InsurancePlanItem[]>>(`/catalogs/insurance-plans${params}`);
    return res.data.data ?? [];
  },

  async getServices(options: { search?: string } = {}): Promise<CatalogItem[]> {
    const params = new URLSearchParams();
    if (options.search) params.set('search', options.search);
    const qs = params.toString();
    const res = await apiClient.get<ApiResponse<CatalogItem[]>>(
      `/catalogs/services${qs ? `?${qs}` : ''}`
    );
    return res.data.data ?? [];
  },
};

export default catalogService;
